enum BindSubmodule {
  BIND = 0x00000100,
}

export { BindSubmodule };
